"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
function MutedOnEnteringCallModal({ handleUnmuteClick, handleCloseModal, }) {
    return ((0, jsx_runtime_1.jsxs)(ui_react_1.Modal, Object.assign({ isOpen: true, onClose: handleCloseModal, mobile: true, closeDelayMS: 200, variant: "danger", cardProps: {
            decoratorPosition: undefined,
        }, styleOverride: {
            overlay: {
                paddingTop: '1rem',
                height: '100%',
                minHeight: '-webkit-fill-available',
                zIndex: '40',
            },
            content: {
                height: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ mb: 24 }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Subheader, Object.assign({ "data-testid": "muted-modal-header", size: "large", bold: true }, { children: "You are muted" })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ mb: 42 }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ "data-testid": "muted-modal-message", as: "p", color: "grey70" }, { children: "To allow others to hear you please unmute yourself" })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ "data-testid": "muting-button", variant: "tertiary", mobile: true, onClick: handleUnmuteClick }, { children: "Unmute" })) }))] })));
}
exports.default = MutedOnEnteringCallModal;
//# sourceMappingURL=muted_on_entering_call_modal.js.map